import React from 'react';
import CrudListPage from './CrudListPage';

// IDI-293: this page used to WRITE the 8 default lead sources into the
// tenant's list whenever the read came back empty. "Empty" included a failed
// or unrecognised read, and for a migrated dealer it meant "not migrated
// yet", so BIDIT's defaults were persisted as the dealer's own data. Seeding
// is the backend's job (net-new tenants only, cmd/settings getSettings); this
// page now only reads.
export default function LeadSourcesPage() {
  return (
    <CrudListPage
      listType="lead_sources"
      title="Lead Sources"
      description="Track where your customers come from."
      fields={[
        { key: 'name', label: 'Source Name', type: 'text', required: true, placeholder: 'e.g., Referral, Google, Facebook' },
        { key: 'description', label: 'Description', type: 'text', required: false, placeholder: 'Optional notes' },
      ]}
      allowReorder
      emptyMessage="No lead sources defined. Add sources to track where your customers come from."
    />
  );
}
